@let isSelected = dataNav().isSelected;
@let name = dataNav().name;
<div [ngClass]="isSelected ? 'select-svg' : 'mood-icons-container'">
  <div class="svg-wrapper">
    @switch (name) {
      @case ('Clients') {
        <svg id="Layer_2" dataNav-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.36 22.36">
          <defs>
            <style>
              .cls-1 {
                fill: none;
              }

              .cls-2 {
                fill: #7c7c7c;
                fill-rule: evenodd;
              }
            </style>
          </defs>
          <g id="Lunch">
            <g>
              <g>
                <path
                  [ngClass]="{ 'active-mood-svg': isSelected === true }"
                  class="cls-2"
                  d="m20.78,20.78c0,.59-.48,1.07-1.07,1.07s-1.07-.48-1.07-1.07v-2.13c0-1.77-1.43-3.2-3.2-3.2H6.91c-1.77,0-3.2,1.43-3.2,3.2v2.13c0,.59-.48,1.07-1.07,1.07s-1.07-.48-1.07-1.07v-2.13c0-2.95,2.39-5.34,5.34-5.34h8.54c2.95,0,5.34,2.39,5.34,5.34v2.13Z"
                />
                <path
                  [ngClass]="{ 'active-mood-svg': isSelected === true }"
                  class="cls-2"
                  d="m5.85,5.85c0,2.95,2.39,5.34,5.34,5.34s5.34-2.39,5.34-5.34S14.13.51,11.18.51s-5.34,2.39-5.34,5.34Zm8.54,0c0,1.77-1.43,3.2-3.2,3.2s-3.2-1.43-3.2-3.2,1.43-3.2,3.2-3.2,3.2,1.43,3.2,3.2Z"
                />
              </g>
              <rect class="cls-1" width="22.36" height="22.36" />
            </g>
          </g>
        </svg>
      }

      @case ('Admins') {
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
          <g clip-path="url(#clip0_22244_8724)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.5 2.43481C8.96998 2.43481 6.91998 4.48481 6.91998 7.01481C6.91998 9.54481 8.96998 11.6048 11.5 11.6048C14.03 11.6048 16.09 9.54481 16.09 7.01481C16.09 4.48481 14.03 2.43481 11.5 2.43481ZM11.5 9.76481C9.97998 9.76481 8.74998 8.53481 8.74998 7.01481C8.74998 5.49481 9.97998 4.26481 11.5 4.26481C13.02 4.26481 14.25 5.49481 14.25 7.01481C14.25 8.53481 13.02 9.76481 11.5 9.76481Z"
              [attr.fill]="isSelected === true ? '#272E5A' : '#7c7c7c'"
            />
            <path
              d="M9.97002 19.8349L7.43002 14.2849C2.22002 15.2549 2.54002 19.8349 2.54002 19.8349H9.97002ZM9.97002 19.8349H11.29H11.72H13.04M13.04 19.8349H20.47C20.47 19.8349 20.8 15.2549 15.58 14.2849L13.04 19.8349Z"
              [attr.stroke]="isSelected === true ? '#272E5A' : '#7c7c7c'"
              stroke-width="1.83"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12.5 13.4749H10.5"
              [attr.stroke]="isSelected === true ? '#272E5A' : '#7c7c7c'"
              stroke-width="1.83"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.54 13.4749L13.49 18.8449"
              [attr.stroke]="isSelected === true ? '#272E5A' : '#7c7c7c'"
              stroke-width="1.83"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.48 13.4749L9.53003 18.8449"
              [attr.stroke]="isSelected === true ? '#272E5A' : '#7c7c7c'"
              stroke-width="1.83"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_22244_8724">
              <rect width="22.36" height="22.36" fill="white" transform="translate(0.320007 0.424805)" />
            </clipPath>
          </defs>
        </svg>
      }

      @case ('Bundles') {
        <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          @if (isSelected === true) {
            <rect x="2.9" y="2.9" width="17.2" height="17.2" rx="2.1" stroke="#272E5A" stroke-width="1.8" />
            <path
              d="M9.94 10.88C9.42 10.88 9 10.46 9 9.94C9 9.42 9.42 9 9.94 9H12.59C13.12 9 13.53 9.41 13.53 9.94C13.53 10.47 13.11 10.88 12.59 10.88H9.94Z"
              fill="#272E5A"
            />
            <path
              d="M8.94 13.7599C8.42 13.7599 8 13.3399 8 12.8199C8 12.2999 8.42 11.8799 8.94 11.8799H13.59C14.11 11.8799 14.53 12.2999 14.53 12.8199C14.53 13.3399 14.12 13.7599 13.59 13.7599H8.94Z"
              fill="#272E5A"
            />
          } @else {
            <rect x="2.9" y="2.9" width="17.2" height="17.2" rx="2.1" stroke="#7c7c7c" stroke-width="1.8" />
            <path
              d="M9.94 10.88C9.42 10.88 9 10.46 9 9.94C9 9.42 9.42 9 9.94 9H12.59C13.12 9 13.53 9.41 13.53 9.94C13.53 10.47 13.11 10.88 12.59 10.88H9.94Z"
              fill="#7c7c7c"
            />
            <path
              d="M8.94 13.7599C8.42 13.7599 8 13.3399 8 12.8199C8 12.2999 8.42 11.8799 8.94 11.8799H13.59C14.11 11.8799 14.53 12.2999 14.53 12.8199C14.53 13.3399 14.12 13.7599 13.59 13.7599H8.94Z"
              fill="#7c7c7c"
            />
          }
        </svg>
      }

      @case ('Configure') {
        <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.36 22.36">
          <defs>
            <style>
              .cls-1 {
                fill: none;
              }

              .cls-2 {
                fill: #7c7c7c;
                fill-rule: evenodd;
              }
            </style>
          </defs>
          <g id="Lunch">
            <g>
              <path
                [ngClass]="{ 'active-mood-svg': isSelected === true }"
                class="cls-2"
                d="m18.99,8.53h.15c1.46,0,2.65,1.19,2.65,2.65s-1.19,2.65-2.65,2.65h-.08c-.23,0-.44.14-.53.35-.1.22-.05.47.1.63l.05.05c.5.5.78,1.17.78,1.88s-.28,1.38-.78,1.87c-.5.5-1.17.78-1.88.78s-1.38-.28-1.88-.78l-.05-.05c-.17-.16-.42-.21-.64-.11-.21.09-.35.3-.35.52v.15c0,1.46-1.19,2.65-2.65,2.65s-2.65-1.19-2.65-2.65c0-.3-.15-.5-.43-.61-.21-.09-.47-.05-.63.11l-.05.05c-.5.5-1.17.78-1.88.78s-1.38-.28-1.88-.78c-.5-.5-.78-1.17-.78-1.88s.28-1.38.78-1.88l.05-.05c.16-.17.21-.42.11-.64-.09-.21-.3-.35-.52-.35h-.15c-1.46,0-2.65-1.19-2.65-2.65s1.19-2.65,2.65-2.65c.29,0,.5-.15.61-.43.09-.21.05-.47-.11-.63l-.05-.05c-.5-.5-.78-1.17-.78-1.88s.28-1.38.78-1.87c.5-.5,1.17-.78,1.88-.78s1.38.28,1.88.78l.05.05c.17.16.42.21.63.11.06-.03.12-.04.18-.06.15-.11.25-.28.25-.47v-.15c0-1.46,1.19-2.65,2.65-2.65s2.65,1.19,2.65,2.65v.08c0,.23.14.43.36.53.21.09.47.05.63-.11l.05-.05c.5-.5,1.17-.78,1.88-.78s1.38.28,1.88.78c.5.5.78,1.17.78,1.88s-.28,1.38-.78,1.88l-.05.05c-.16.17-.21.42-.11.63.02.06.04.11.06.18.11.15.28.25.47.25Zm.07,3.54h.08c.49,0,.88-.4.88-.88s-.4-.88-.88-.88h-.15c-.93,0-1.78-.56-2.14-1.42-.03-.08-.05-.15-.06-.23-.29-.83-.09-1.77.54-2.42l.05-.05c.17-.16.26-.39.26-.62s-.09-.46-.26-.63c-.17-.16-.39-.26-.63-.26s-.46.09-.63.26l-.06.06c-.68.67-1.71.86-2.58.47-.86-.37-1.42-1.21-1.42-2.15v-.08c0-.49-.4-.88-.88-.88s-.88.4-.88.88v.15c0,.93-.56,1.78-1.42,2.14-.08.03-.15.05-.23.06-.84.29-1.77.09-2.42-.54l-.05-.05c-.17-.16-.39-.26-.62-.26s-.46.09-.63.26c-.17.17-.26.39-.26.62s.09.46.26.63l.06.06c.67.68.85,1.71.49,2.53-.33.9-1.18,1.51-2.16,1.53h-.08c-.49,0-.88.4-.88.88s.4.88.88.88h.15c.93,0,1.78.56,2.14,1.41.39.88.2,1.9-.48,2.59l-.05.05c-.17.16-.26.39-.26.63s.09.46.26.63c.17.17.39.26.63.26s.46-.09.63-.26l.06-.06c.68-.67,1.71-.86,2.53-.49.9.33,1.51,1.18,1.53,2.16v.08c0,.49.4.88.88.88s.88-.4.88-.88v-.16c0-.93.56-1.78,1.41-2.14.88-.39,1.9-.2,2.59.48l.05.05c.17.17.39.26.63.26s.46-.09.63-.26c.17-.17.26-.39.26-.62s-.09-.46-.26-.63l-.06-.06c-.67-.68-.85-1.7-.47-2.58.37-.86,1.21-1.41,2.15-1.42Zm-7.88,2.65c-1.95,0-3.54-1.58-3.54-3.54s1.58-3.54,3.54-3.54,3.54,1.58,3.54,3.54-1.58,3.54-3.54,3.54Zm0-1.77c.98,0,1.77-.79,1.77-1.77s-.79-1.77-1.77-1.77-1.77.79-1.77,1.77.79,1.77,1.77,1.77Z"
              />
              <rect class="cls-1" width="22.36" height="22.36" />
            </g>
          </g>
        </svg>
      }

      @case ('Daily Meals') {
        <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.36 22.36">
          <defs>
            <style>
              .cls-1 {
                fill: none;
              }

              .cls-2,
              .cls-3 {
                fill: #7c7c7c;
              }

              .cls-3 {
                fill-rule: evenodd;
              }
            </style>
          </defs>
          <g id="Lunch">
            <g>
              <g>
                <path
                  [ngClass]="{ 'active-mood-svg': isSelected === true }"
                  class="cls-2"
                  d="m21.25,13.74c-.24-.42-.55-.75-.93-.99-.37-.24-.81-.38-1.3-.43-.52-.05-.98.08-1.39.19-.25.07-.48.13-.66.13s-.41-.06-.65-.13c-.41-.11-.87-.24-1.39-.19-.95.09-1.71.57-2.19,1.41-.41.7-.62,1.64-.62,2.8,0,1.87,1.47,4.86,3.21,4.86.79,0,1.23-.25,1.51-.42.04-.03.1-.06.13-.07.03.01.09.05.13.07.29.17.72.42,1.51.42,1.74,0,3.21-2.98,3.21-4.86,0-1.18-.19-2.09-.59-2.79Zm-1.85,4.71c-.35.66-.68.97-.82,1.04-.25,0-.34-.06-.52-.16-.23-.13-.57-.33-1.08-.33s-.85.2-1.08.33c-.18.1-.27.16-.52.16-.13-.07-.47-.39-.82-1.04-.34-.65-.55-1.38-.55-1.92,0-1.01.2-1.56.36-1.84.18-.3.4-.45.74-.48.18-.02.44.05.71.13.34.09.72.2,1.15.2s.82-.11,1.16-.2c.25-.07.48-.13.66-.13.02,0,.04,0,.06,0,.36.03.58.17.75.47.16.27.34.81.34,1.85,0,.54-.21,1.28-.55,1.92Z"
                />
                <path
                  [ngClass]="{ 'active-mood-svg': isSelected === true }"
                  class="cls-2"
                  d="m18.92,11.49c-.56.56-1.21.72-1.56.76-.12.02-.22-.06-.24-.18,0-.02,0-.03,0-.05.06-.6.33-1.15.76-1.57.58-.58,1.22-.71,1.56-.74.12-.01.22.08.23.19,0,.02,0,.03,0,.04-.07.58-.33,1.13-.75,1.54h0Z"
                />
                <path
                  [ngClass]="{ 'active-mood-svg': isSelected === true }"
                  class="cls-2"
                  d="m16.8,16.86c0,.64-.27,1.12-.63,1.12s-.63-.48-.63-1.12.27-1.12.63-1.12.63.48.63,1.12Z"
                />
                <path
                  [ngClass]="{ 'active-mood-svg': isSelected === true }"
                  class="cls-2"
                  d="m18.43,16.86c0,.64-.27,1.12-.63,1.12s-.63-.48-.63-1.12.27-1.12.63-1.12.63.48.63,1.12Z"
                />
                <path
                  [ngClass]="{ 'active-mood-svg': isSelected === true }"
                  class="cls-3"
                  d="m16.34.97H3.31C1.77.97.52,2.22.52,3.77v14.8c0,1.54,1.25,2.79,2.79,2.79h7.59c.51,0,.93-.42.93-.93s-.42-.93-.93-.93H3.31c-.51,0-.93-.42-.93-.93V3.77c0-.52.42-.93.93-.93h13.03c.51,0,.93.42.93.93v3.93c0,.38.23.7.55.85.12.05.25.08.38.08s.27-.03.38-.08c.32-.15.55-.47.55-.85v-3.93c0-1.54-1.25-2.79-2.79-2.79Z"
                />
                <path
                  [ngClass]="{ 'active-mood-svg': isSelected === true }"
                  class="cls-2"
                  d="m7.39,7.48l3.57,3.21c.25.23.27.61.04.86l-2.11,2.35c-.19.21-.44.31-.7.31-.23,0-.45-.08-.63-.24-.39-.35-.42-.95-.07-1.34l1.26-1.39-2.62-2.36c-.39-.35-.42-.95-.07-1.34.35-.39.95-.42,1.34-.07h0Z"
                />
              </g>
              <rect class="cls-1" width="22.36" height="22.36" />
            </g>
          </g>
        </svg>
      }

      @case ('Daily Workouts') {
        <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.36 22.36">
          <defs>
            <style>
              .cls-1 {
                fill: none;
              }

              .cls-2,
              .cls-3 {
                fill: #7c7c7c;
              }

              .cls-3 {
                fill-rule: evenodd;
              }
            </style>
          </defs>
          <g id="Lunch">
            <g>
              <g>
                <path
                  [ngClass]="{ 'active-mood-svg': isSelected === true }"
                  class="cls-3"
                  d="m17.22.52H3.65C2.04.52.74,1.82.74,3.43v15.41c0,1.61,1.3,2.91,2.91,2.91h5.72c.54,0,.97-.43.97-.97s-.43-.97-.97-.97H3.65c-.53,0-.97-.43-.97-.97V3.43c0-.54.43-.97.97-.97h13.57c.53,0,.97.43.97.97v4.1c0,.39.23.73.57.88.12.06.26.09.4.09s.28-.03.4-.09c.34-.15.57-.49.57-.88V3.43c0-1.61-1.3-2.91-2.91-2.91Z"
                />
                <path
                  [ngClass]="{ 'active-mood-svg': isSelected === true }"
                  class="cls-2"
                  d="m10.76,12.54l-1.31,1.45c-.19.22-.46.33-.73.33-.24,0-.47-.08-.66-.25-.4-.36-.44-.99-.07-1.39l1.31-1.45-2.72-2.45c-.4-.36-.44-.99-.07-1.39.36-.4.99-.44,1.39-.07l3.18,2.86c-.4.72-.51,1.57-.31,2.37Z"
                />
                <path
                  [ngClass]="{ 'active-mood-svg': isSelected === true }"
                  class="cls-2"
                  d="m19.95,14.57l.81-2.06c.25-.64.17-1.36-.22-1.93-.39-.57-1.03-.91-1.71-.91h-4.91c-.68,0-1.32.34-1.71.9-.39.56-.47,1.28-.23,1.92l.8,2.1c-1.02.96-1.65,2.31-1.65,3.82,0,1.09.33,2.13.95,3.02.18.26.48.42.8.42h6.97c.32,0,.62-.15.8-.42.62-.89.95-1.93.95-3.02,0-1.51-.64-2.88-1.67-3.83Zm-6.13-2.79s-.02-.05.01-.1c.03-.05.07-.05.09-.05h4.91s.06,0,.09.05c.03.04.02.08.01.1l-.68,1.72c-.58-.22-1.21-.35-1.87-.35s-1.31.13-1.89.35l-.66-1.73h0Zm5.48,8.08h-5.86c-.23-.45-.34-.95-.34-1.46,0-1.8,1.47-3.27,3.27-3.27s3.27,1.47,3.27,3.27c0,.51-.12,1.01-.34,1.46Z"
                />
              </g>
              <rect class="cls-1" width="22.36" height="22.36" />
            </g>
          </g>
        </svg>
      }

      @case ('Dashboard') {
        <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.36 22.36">
          <defs>
            <style>
              .cls-1 {
                fill: none;
              }

              .cls-2 {
                fill: #7c7c7c;
                fill-rule: evenodd;
              }
            </style>
          </defs>
          <g id="Lunch">
            <g>
              <path
                [ngClass]="{ 'active-mood-svg': isSelected === true }"
                class="cls-2"
                d="m2.65,7.98h5.33V2.65H2.65v5.33ZM1.58.51h7.47c.59,0,1.07.48,1.07,1.07v7.47c0,.59-.48,1.07-1.07,1.07H1.58c-.59,0-1.07-.48-1.07-1.07V1.58C.51.99.99.51,1.58.51Zm11.73,0h7.47c.59,0,1.07.48,1.07,1.07v7.47c0,.59-.48,1.07-1.07,1.07h-7.47c-.59,0-1.07-.48-1.07-1.07V1.58c0-.59.48-1.07,1.07-1.07Zm1.07,7.47h5.33V2.65h-5.33v5.33Zm-1.07,4.27h7.47c.59,0,1.07.48,1.07,1.07v7.47c0,.59-.48,1.07-1.07,1.07h-7.47c-.59,0-1.07-.48-1.07-1.07v-7.47c0-.59.48-1.07,1.07-1.07Zm1.07,7.47h5.33v-5.33h-5.33v5.33ZM1.58,12.25h7.47c.59,0,1.07.48,1.07,1.07v7.47c0,.59-.48,1.07-1.07,1.07H1.58c-.59,0-1.07-.48-1.07-1.07v-7.47c0-.59.48-1.07,1.07-1.07Zm1.07,7.47h5.33v-5.33H2.65v5.33Z"
              />
              <rect class="cls-1" width="22.36" height="22.36" />
            </g>
          </g>
        </svg>
      }

      @case ('Workouts') {
        <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.36 22.36">
          <defs>
            <style>
              .cls-1 {
                fill: none;
              }

              .cls-2 {
                fill: #7c7c7c;
              }
            </style>
          </defs>
          <g id="Lunch">
            <g>
              <path
                [ngClass]="{ 'active-mood-svg': isSelected === true }"
                class="cls-2"
                d="m16.67,9.19l1.77-4.5c.37-.94.25-2-.32-2.84-.57-.84-1.51-1.34-2.52-1.34H6.27c-1.01,0-1.95.49-2.52,1.32-.57.83-.7,1.88-.34,2.82l1.74,4.57c-2.01,1.67-3.3,4.18-3.3,6.99,0,1.88.57,3.69,1.65,5.22.18.26.49.42.81.42h13.24c.32,0,.62-.16.81-.42,1.08-1.53,1.65-3.34,1.65-5.22,0-2.83-1.3-5.36-3.34-7.03h0ZM5.26,3.95c-.13-.34-.09-.7.12-1,.2-.3.53-.47.89-.47h9.33c.36,0,.69.17.89.47.2.3.25.67.11,1.01l-1.63,4.13c-1.22-.61-2.59-.95-4.05-.95s-2.86.35-4.09.98l-1.59-4.16h0Zm11.76,15.93H4.85c-.67-1.1-1.02-2.36-1.02-3.67,0-3.92,3.19-7.1,7.1-7.1s7.1,3.19,7.1,7.1c0,1.31-.35,2.56-1.02,3.67Z"
              />
              <rect class="cls-1" width="22.36" height="22.36" />
            </g>
          </g>
        </svg>
      }

      @case ('Meals') {
        <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.36 22.36">
          <defs>
            <style>
              .cls-1 {
                fill: none;
              }

              .cls-2 {
                fill: #7c7c7c;
              }
            </style>
          </defs>
          <g id="Lunch">
            <g>
              <g>
                <path
                  [ngClass]="{ 'active-mood-svg': isSelected === true }"
                  class="cls-2"
                  d="m14.72,21.82c-1.42,0-2.18-.44-2.73-.75-.37-.21-.53-.3-.81-.3s-.44.09-.81.3c-.55.32-1.31.75-2.73.75-.75,0-1.53-.36-2.3-1.08-.61-.57-1.22-1.36-1.76-2.3-1.12-1.94-1.79-4.19-1.79-6,0-6.53,3.19-7.8,5.09-7.98.94-.09,1.83.16,2.61.37.6.16,1.16.32,1.68.32s1.08-.16,1.68-.32c.78-.22,1.67-.46,2.6-.38,1.74.16,3.11,1.03,3.97,2.52.76,1.33,1.13,3.12,1.13,5.47,0,1.81-.67,4.06-1.79,6-.54.93-1.15,1.73-1.76,2.3-.77.72-1.55,1.08-2.3,1.08h0Zm-3.53-3.02c.82,0,1.36.31,1.79.56.46.26.85.49,1.74.49.39,0,1.34-.64,2.35-2.39.94-1.63,1.53-3.56,1.53-5.02,0-1.97-.29-3.48-.87-4.49-.54-.95-1.31-1.43-2.43-1.53-.58-.05-1.22.13-1.91.31-.7.19-1.42.39-2.21.39s-1.5-.2-2.2-.39c-.68-.19-1.33-.37-1.91-.31-1.06.1-1.84.6-2.39,1.54-.61,1.03-.91,2.54-.91,4.48,0,1.46.58,3.39,1.53,5.02,1.01,1.76,1.96,2.39,2.35,2.39.9,0,1.29-.23,1.74-.49.43-.25.97-.56,1.79-.56h0Z"
                />
                <path
                  [ngClass]="{ 'active-mood-svg': isSelected === true }"
                  class="cls-2"
                  d="m14.15,3.48c-.92.92-2,1.18-2.57,1.26-.19.03-.37-.11-.4-.3,0-.03,0-.06,0-.09.1-.98.55-1.9,1.25-2.6.96-.96,2.01-1.18,2.57-1.22.19-.02.36.12.38.32,0,.02,0,.05,0,.07-.11.96-.54,1.86-1.23,2.55h0Z"
                />
                <path
                  [ngClass]="{ 'active-mood-svg': isSelected === true }"
                  class="cls-2"
                  d="m9.43,15.24c.58,0,1.05-.94,1.05-2.1s-.47-2.1-1.05-2.1-1.05.94-1.05,2.1.47,2.1,1.05,2.1Z"
                />
                <path
                  [ngClass]="{ 'active-mood-svg': isSelected === true }"
                  class="cls-2"
                  d="m12.93,15.24c.58,0,1.05-.94,1.05-2.1s-.47-2.1-1.05-2.1-1.05.94-1.05,2.1.47,2.1,1.05,2.1Z"
                />
              </g>
              <rect class="cls-1" width="22.36" height="22.36" />
            </g>
          </g>
        </svg>
      }

      @case ('Reflections') {
        <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.36 22.36">
          <defs>
            <style>
              .cls-1 {
                fill: none;
              }

              .cls-2 {
                fill: #7c7c7c;
                fill-rule: evenodd;
              }
            </style>
          </defs>
          <g id="Lunch">
            <g>
              <rect class="cls-1" width="22.36" height="22.36" />
              <g>
                <path
                  [ngClass]="{ 'active-mood-svg': isSelected === true }"
                  class="cls-2"
                  d="m11.36,21.66l-1.07-1.23,6.94-6.02c.4-.39,1.11-.39,1.54.03l2.45,2.4-1.14,1.17-2.12-2.08-6.6,5.73Z"
                />
                <path
                  [ngClass]="{ 'active-mood-svg': isSelected === true }"
                  class="cls-2"
                  d="m10.62,20.23h9.01c.22,0,.4-.18.4-.4v-7.37c0-.22-.18-.4-.4-.4h-9.01c-.22,0-.4.18-.4.4v7.37c0,.22.18.4.4.4Zm9.41,1.64h-9.82c-.9,0-1.64-.73-1.64-1.64v-8.18c0-.9.73-1.64,1.64-1.64h9.82c.9,0,1.64.73,1.64,1.64v8.18c0,.9-.73,1.64-1.64,1.64Z"
                />
                <path
                  [ngClass]="{ 'active-mood-svg': isSelected === true }"
                  class="cls-2"
                  d="m12.59,15.87c0,.39-.32.7-.72.7s-.72-.31-.72-.7.32-.7.72-.7.72.31.72.7Z"
                />
              </g>
              <path
                [ngClass]="{ 'active-mood-svg': isSelected === true }"
                class="cls-2"
                d="m16.72,2.38h-1.9c0-1.03-.85-1.88-1.88-1.88h-5.62c-1.03,0-1.88.85-1.88,1.88h-1.92c-1.56,0-2.82,1.26-2.82,2.81v13.87c0,1.55,1.26,2.81,2.82,2.81h2.42c.52,0,.93-.42.93-.93h0c0-.52-.42-.93-.93-.93h-2.42c-.53,0-.94-.42-.94-.94V5.19c0-.52.41-.93.94-.93h1.92c0,1.03.85,1.87,1.88,1.87h5.62c1.03,0,1.88-.84,1.88-1.87h1.9c.53,0,.94.41.94.93v2.58c0,.52.42.94.94.94s.94-.42.94-.94v-2.58c0-1.55-1.26-2.81-2.82-2.81Zm-3.98,1.88h-5.23c-.11,0-.2-.09-.2-.2v-1.48c0-.11.09-.2.2-.2h5.23c.11,0,.2.09.2.2v1.48c0,.11-.09.2-.2.2Z"
              />
            </g>
          </g>
        </svg>
      }

      @case ('Coaches') {
        <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.36 22.36">
          <defs>
            <style>
              .cls-1 {
                fill: none;
              }

              .cls-2 {
                fill: #7c7c7c;
                fill-rule: evenodd;
              }
            </style>
          </defs>
          <g id="Lunch">
            <g>
              <path
                [ngClass]="{ 'active-mood-svg': isSelected === true }"
                class="cls-2"
                d="m16.68,19.43c0,.51-.41.92-.92.92s-.92-.41-.92-.92v-1.83c0-1.52-1.23-2.75-2.75-2.75h-7.33c-1.52,0-2.75,1.23-2.75,2.75v1.83c0,.51-.41.92-.92.92s-.92-.41-.92-.92v-1.83c0-2.53,2.05-4.58,4.58-4.58h7.33c2.53,0,4.58,2.05,4.58,4.58v1.83Zm-8.25-8.25c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58,4.58,2.05,4.58,4.58-2.05,4.58-4.58,4.58h0Zm0-1.83c1.52,0,2.75-1.23,2.75-2.75s-1.23-2.75-2.75-2.75-2.75,1.23-2.75,2.75,1.23,2.75,2.75,2.75h0Zm13.75,10.09c0,.51-.41.92-.92.92s-.92-.41-.92-.92v-1.83c0-1.25-.85-2.35-2.06-2.66-.49-.13-.78-.63-.66-1.12s.63-.79,1.12-.66c2.02.52,3.44,2.35,3.44,4.44v1.83ZM14.62,3.94c-.49-.12-.79-.62-.66-1.11.13-.49.63-.79,1.12-.66,2.03.52,3.45,2.35,3.45,4.44s-1.42,3.92-3.45,4.44c-.49.12-.99-.17-1.12-.66-.13-.49.17-.99.66-1.12,1.22-.31,2.07-1.41,2.07-2.66s-.85-2.35-2.07-2.66h0Z"
              />
              <rect class="cls-1" width="22.36" height="22.36" />
            </g>
          </g>
        </svg>
      }

      @case ('Teams') {
        <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.34 22.36">
          <defs>
            <style>
              .cls-1 {
                fill: none;
              }

              .cls-2 {
                fill: #7c7c7c;
                fill-rule: evenodd;
              }
            </style>
          </defs>
          <g id="Lunch">
            <g>
              <g>
                <g>
                  <path
                    [ngClass]="{ 'active-mood-svg': isSelected === true }"
                    class="cls-2"
                    d="m15.34,13.01h-6.34c-2.53,0-4.59,2.05-4.59,4.58v1.84c0,.5.41.91.92.91s.92-.41.92-.91v-1.84c0-1.52,1.23-2.75,2.75-2.75h6.34c1.52,0,2.75,1.23,2.75,2.75v1.84c0,.5.41.91.92.91s.91-.41.91-.91v-1.84c0-2.53-2.05-4.58-4.58-4.58Z"
                  />
                  <path
                    [ngClass]="{ 'active-mood-svg': isSelected === true }"
                    class="cls-2"
                    d="m12.16,2.01c-2.53,0-4.58,2.05-4.58,4.58s2.05,4.59,4.58,4.59,4.59-2.06,4.59-4.59-2.06-4.58-4.59-4.58Zm0,7.33c-1.52,0-2.75-1.23-2.75-2.75s1.23-2.75,2.75-2.75,2.75,1.23,2.75,2.75-1.23,2.75-2.75,2.75Z"
                  />
                </g>
                <g>
                  <path
                    [ngClass]="{ 'active-mood-svg': isSelected === true }"
                    class="cls-2"
                    d="m24.2,17.6v1.83c0,.51-.41.92-.91.92s-.92-.41-.92-.92v-1.83c0-1.26-.85-2.35-2.06-2.66-.49-.13-.79-.63-.66-1.12s.63-.79,1.12-.66c2.02.52,3.43,2.35,3.43,4.44Z"
                  />
                  <path
                    [ngClass]="{ 'active-mood-svg': isSelected === true }"
                    class="cls-2"
                    d="m21.03,6.6c0,2.09-1.42,3.92-3.44,4.44-.49.13-.99-.17-1.12-.66-.12-.49.17-.99.66-1.12,1.22-.31,2.07-1.4,2.07-2.66s-.85-2.35-2.07-2.66c-.49-.13-.78-.63-.66-1.12.13-.49.63-.79,1.12-.66,2.02.52,3.44,2.35,3.44,4.44Z"
                  />
                </g>
                <g>
                  <path
                    [ngClass]="{ 'active-mood-svg': isSelected === true }"
                    class="cls-2"
                    d="m.14,17.6v1.83c0,.51.41.92.91.92s.92-.41.92-.92v-1.83c0-1.26.85-2.35,2.06-2.66.49-.13.79-.63.66-1.12s-.63-.79-1.12-.66C1.55,13.68.14,15.51.14,17.6Z"
                  />
                  <path
                    [ngClass]="{ 'active-mood-svg': isSelected === true }"
                    class="cls-2"
                    d="m3.3,6.6c0,2.09,1.42,3.92,3.44,4.44.49.13.99-.17,1.12-.66.12-.49-.17-.99-.66-1.12-1.22-.31-2.07-1.4-2.07-2.66,0-1.26.85-2.35,2.07-2.66.49-.13.78-.63.66-1.12-.13-.49-.63-.79-1.12-.66-2.02.52-3.44,2.35-3.44,4.44Z"
                  />
                </g>
              </g>
              <rect class="cls-1" width="24.34" height="22.36" />
            </g>
          </g>
        </svg>
      }

      @case ('Settings') {
        <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.36 22.36">
          <defs>
            <style>
              .cls-1 {
                fill: none;
              }

              .cls-2 {
                fill: #7c7c7c;
                fill-rule: evenodd;
              }
            </style>
          </defs>
          <g id="Lunch">
            <g>
              <path
                [ngClass]="{ 'active-mood-svg': isSelected === true }"
                class="cls-2"
                d="m18.99,8.53h.15c1.46,0,2.65,1.19,2.65,2.65s-1.19,2.65-2.65,2.65h-.08c-.23,0-.44.14-.53.35-.1.22-.05.47.1.63l.05.05c.5.5.78,1.17.78,1.88s-.28,1.38-.78,1.87c-.5.5-1.17.78-1.88.78s-1.38-.28-1.88-.78l-.05-.05c-.17-.16-.42-.21-.64-.11-.21.09-.35.3-.35.52v.15c0,1.46-1.19,2.65-2.65,2.65s-2.65-1.19-2.65-2.65c0-.3-.15-.5-.43-.61-.21-.09-.47-.05-.63.11l-.05.05c-.5.5-1.17.78-1.88.78s-1.38-.28-1.88-.78c-.5-.5-.78-1.17-.78-1.88s.28-1.38.78-1.88l.05-.05c.16-.17.21-.42.11-.64-.09-.21-.3-.35-.52-.35h-.15c-1.46,0-2.65-1.19-2.65-2.65s1.19-2.65,2.65-2.65c.29,0,.5-.15.61-.43.09-.21.05-.47-.11-.63l-.05-.05c-.5-.5-.78-1.17-.78-1.88s.28-1.38.78-1.87c.5-.5,1.17-.78,1.88-.78s1.38.28,1.88.78l.05.05c.17.16.42.21.63.11.06-.03.12-.04.18-.06.15-.11.25-.28.25-.47v-.15c0-1.46,1.19-2.65,2.65-2.65s2.65,1.19,2.65,2.65v.08c0,.23.14.43.36.53.21.09.47.05.63-.11l.05-.05c.5-.5,1.17-.78,1.88-.78s1.38.28,1.88.78c.5.5.78,1.17.78,1.88s-.28,1.38-.78,1.88l-.05.05c-.16.17-.21.42-.11.63.02.06.04.11.06.18.11.15.28.25.47.25Zm.07,3.54h.08c.49,0,.88-.4.88-.88s-.4-.88-.88-.88h-.15c-.93,0-1.78-.56-2.14-1.42-.03-.08-.05-.15-.06-.23-.29-.83-.09-1.77.54-2.42l.05-.05c.17-.16.26-.39.26-.62s-.09-.46-.26-.63c-.17-.16-.39-.26-.63-.26s-.46.09-.63.26l-.06.06c-.68.67-1.71.86-2.58.47-.86-.37-1.42-1.21-1.42-2.15v-.08c0-.49-.4-.88-.88-.88s-.88.4-.88.88v.15c0,.93-.56,1.78-1.42,2.14-.08.03-.15.05-.23.06-.84.29-1.77.09-2.42-.54l-.05-.05c-.17-.16-.39-.26-.62-.26s-.46.09-.63.26c-.17.17-.26.39-.26.62s.09.46.26.63l.06.06c.67.68.85,1.71.49,2.53-.33.9-1.18,1.51-2.16,1.53h-.08c-.49,0-.88.4-.88.88s.4.88.88.88h.15c.93,0,1.78.56,2.14,1.41.39.88.2,1.9-.48,2.59l-.05.05c-.17.16-.26.39-.26.63s.09.46.26.63c.17.17.39.26.63.26s.46-.09.63-.26l.06-.06c.68-.67,1.71-.86,2.53-.49.9.33,1.51,1.18,1.53,2.16v.08c0,.49.4.88.88.88s.88-.4.88-.88v-.16c0-.93.56-1.78,1.41-2.14.88-.39,1.9-.2,2.59.48l.05.05c.17.17.39.26.63.26s.46-.09.63-.26c.17-.17.26-.39.26-.62s-.09-.46-.26-.63l-.06-.06c-.67-.68-.85-1.7-.47-2.58.37-.86,1.21-1.41,2.15-1.42Zm-7.88,2.65c-1.95,0-3.54-1.58-3.54-3.54s1.58-3.54,3.54-3.54,3.54,1.58,3.54,3.54-1.58,3.54-3.54,3.54Zm0-1.77c.98,0,1.77-.79,1.77-1.77s-.79-1.77-1.77-1.77-1.77.79-1.77,1.77.79,1.77,1.77,1.77Z"
              />
              <rect class="cls-1" width="22.36" height="22.36" />
            </g>
          </g>
        </svg>
      }

      @case ('Habits') {
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <style>
              .cls-2 {
                fill: #7c7c7c;
                fill-rule: evenodd;
              }
            </style>
          </defs>
          <g id="Vector">
            <path
              class="cls-2"
              [ngClass]="{ 'active-mood-svg': isSelected === true }"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.9976 2.0015C10.2236 2.0015 9.45063 2.1025 8.68262 2.3045C7.14962 2.7075 5.79063 3.4945 4.64262 4.6435C3.49362 5.7915 2.70663 7.1505 2.30463 8.6825C1.90063 10.2205 1.89963 11.7785 2.30463 13.3155C2.70763 14.8495 3.49463 16.2085 4.64262 17.3555C5.79063 18.5045 7.15062 19.2915 8.68363 19.6945C10.2206 20.0975 11.7796 20.0985 13.3156 19.6935C14.8476 19.2925 16.2056 18.5055 17.3556 17.3555C18.5046 16.2075 19.2906 14.8485 19.6936 13.3155V13.3145C20.0986 11.7805 20.0986 10.2225 19.6936 8.6835C19.2916 7.1505 18.5046 5.7915 17.3556 4.6435C16.2066 3.4935 14.8476 2.7065 13.3156 2.3045C12.5466 2.1025 11.7716 2.0015 10.9976 2.0015ZM10.9976 21.9975C10.0546 21.9975 9.11163 21.8745 8.17463 21.6285C6.29463 21.1345 4.63063 20.1725 3.22763 18.7705C1.82663 17.3695 0.865625 15.7055 0.369625 13.8245C-0.123375 11.9495 -0.123375 10.0495 0.370625 8.1745C0.864625 6.2955 1.82563 4.6315 3.22763 3.2295C4.62962 1.8265 6.29362 0.8645 8.17362 0.3705C10.0456 -0.1235 11.9476 -0.1235 13.8236 0.3705C15.7026 0.8635 17.3666 1.8255 18.7696 3.2295C20.1726 4.6315 21.1346 6.2955 21.6286 8.1755C22.1216 10.0515 22.1216 11.9515 21.6286 13.8235C21.1336 15.7045 20.1726 17.3685 18.7696 18.7705C17.3666 20.1745 15.7026 21.1355 13.8236 21.6285C12.8866 21.8745 11.9426 21.9975 10.9976 21.9975Z"
            />
            <path
              class="cls-2"
              [ngClass]="{ 'active-mood-svg': isSelected === true }"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.439 14.6079C9.199 14.6079 8.96 14.5219 8.769 14.3499L6.009 11.8579C5.599 11.4879 5.567 10.8549 5.937 10.4459C6.306 10.0349 6.939 10.0029 7.35 10.3739L9.4 12.2249L14.567 6.9999C14.955 6.6059 15.589 6.6039 15.981 6.9919C16.374 7.3799 16.378 8.0129 15.989 8.4059L10.15 14.3109C9.955 14.5079 9.697 14.6079 9.439 14.6079Z"
            />
          </g>
        </svg>
      }

      @case ('Quiz') {
        <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.36 22.36">
          <defs>
            <style>
              .cls-1 {
                fill: none;
              }

              .cls-1,
              .cls-2,
              .cls-3 {
                stroke-width: 0px;
              }

              .cls-2 {
                fill-rule: evenodd;
              }

              .cls-2,
              .cls-3 {
                fill: #7c7c7c;
              }
            </style>
          </defs>
          <g id="Lunch">
            <g>
              <rect class="cls-1" width="22.36" height="22.36" />
              <path
                [ngClass]="{ 'active-mood-svg': isSelected === true }"
                class="cls-2"
                d="m16.72,2.38h-1.9c0-1.03-.85-1.88-1.88-1.88h-5.62c-1.03,0-1.88.85-1.88,1.88h-1.92c-1.56,0-2.82,1.26-2.82,2.81v13.87c0,1.55,1.26,2.81,2.82,2.81h4.6c.52,0,.93-.42.93-.93h0c0-.52-.42-.93-.93-.93H3.51c-.53,0-.94-.42-.94-.94V5.19c0-.52.41-.93.94-.93h1.92c0,1.03.85,1.87,1.88,1.87h5.62c1.03,0,1.88-.84,1.88-1.87h1.9c.53,0,.94.41.94.93v5.52c0,.52.42.94.94.94s.94-.42.94-.94v-5.52c0-1.55-1.26-2.81-2.82-2.81Zm-3.98,1.88h-5.23c-.11,0-.2-.09-.2-.2v-1.48c0-.11.09-.2.2-.2h5.23c.11,0,.2.09.2.2v1.48c0,.11-.09.2-.2.2Z"
              />
              <path
                [ngClass]="{ 'active-mood-svg': isSelected === true }"
                class="cls-3"
                d="m13.8,21.64h0c-.25,0-.48-.1-.66-.27l-3.41-3.41c-.36-.36-.36-.95,0-1.32s.95-.36,1.32,0l2.75,2.75,5.84-5.84c.36-.36.95-.36,1.32,0,.36.36.36.95,0,1.32l-6.5,6.5c-.17.17-.41.27-.66.27Z"
              />
            </g>
          </g>
        </svg>
      }

      @case ('Organizations') {
        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="Lunch">
            <g id="Group">
              <path
                [ngClass]="{ 'active-mood-svg': isSelected === true }"
                id="Vector"
                d="M3.05001 21.38C2.03001 21.38 1.20001 20.55 1.20001 19.53V2.82998C1.20001 1.80998 2.03001 0.97998 3.05001 0.97998C3.13001 0.97998 3.22001 0.97998 3.30001 0.99998L12.5 2.30998C13.41 2.44998 14.09 3.22998 14.09 4.13998V8.30998L20.34 9.47998H20.43C21.22 9.63998 21.79 10.32 21.79 11.11V19.71C21.79 20.62 21.05 21.37 20.13 21.37H3.05001V21.38ZM12.27 19.55V4.14998L3.06001 2.81998L3.04001 19.55H4.81001V14.91C4.81001 13.92 5.62001 13.11 6.61001 13.11H9.05001C10.04 13.11 10.85 13.92 10.85 14.91V19.55H12.27ZM19.93 19.53V11.34L14.14 10.21V19.53H19.93ZM8.98001 19.51V14.96L6.69001 14.99V19.51H8.98001Z"
                fill="#7C7C7C"
              />
              <g id="Group_2">
                <path
                  [ngClass]="{ 'active-mood-svg': isSelected === true }"
                  id="Vector_2"
                  d="M16.22 14.9899C15.7 14.9899 15.28 14.5699 15.28 14.0499C15.28 13.5299 15.7 13.1099 16.22 13.1099H17.87C18.4 13.1099 18.81 13.5199 18.81 14.0499C18.81 14.5799 18.39 14.9899 17.87 14.9899H16.22Z"
                  fill="#7C7C7C"
                />
                <path
                  [ngClass]="{ 'active-mood-svg': isSelected === true }"
                  id="Vector_3"
                  d="M16.22 17.84C15.7 17.84 15.28 17.42 15.28 16.9C15.28 16.38 15.7 15.96 16.22 15.96H17.87C18.39 15.96 18.81 16.38 18.81 16.9C18.81 17.42 18.4 17.84 17.87 17.84H16.22Z"
                  fill="#7C7C7C"
                />
              </g>
            </g>
          </g>
        </svg>
      }

      @case ('Groups') {
        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="Group icon">
            <g id="Lunch">
              <g id="Group">
                <g id="Group_2">
                  <path
                    [ngClass]="{ 'active-mood-svg': isSelected === true }"
                    id="Vector"
                    d="M9.65 10.7199H2C1.41 10.7199 0.940002 10.2399 0.940002 9.65994V1.99994C0.940002 1.40994 1.42 0.939941 2 0.939941H9.65C10.24 0.939941 10.71 1.41994 10.71 1.99994V9.64994C10.71 10.2399 10.23 10.7099 9.65 10.7099V10.7199ZM3.06 8.58994H8.59V3.05994H3.06V8.58994Z"
                    fill="#7C7C7C"
                  />
                  <path
                    [ngClass]="{ 'active-mood-svg': isSelected === true }"
                    h
                    id="Vector_2"
                    d="M9.65 22.1401H2C1.41 22.1401 0.940002 21.6601 0.940002 21.0801V13.4301C0.940002 12.8401 1.42 12.3701 2 12.3701H9.65C10.24 12.3701 10.71 12.8501 10.71 13.4301V21.0801C10.71 21.6701 10.23 22.1401 9.65 22.1401ZM3.06 20.0201H8.59V14.4901H3.06V20.0201Z"
                    fill="#7C7C7C"
                  />
                  <path
                    [ngClass]="{ 'active-mood-svg': isSelected === true }"
                    id="Vector_3"
                    d="M21 22.1401H13.35C12.76 22.1401 12.29 21.6601 12.29 21.0801V13.4301C12.29 12.8401 12.77 12.3701 13.35 12.3701H21C21.59 12.3701 22.06 12.8501 22.06 13.4301V21.0801C22.06 21.6701 21.58 22.1401 21 22.1401ZM14.41 20.0201H19.94V14.4901H14.41V20.0201Z"
                    fill="#7C7C7C"
                  />
                  <path
                    [ngClass]="{ 'active-mood-svg': isSelected === true }"
                    id="Vector_4"
                    d="M17.17 10.7199C16.58 10.7199 16.11 10.2399 16.11 9.65994V1.99994C16.11 1.40994 16.59 0.939941 17.17 0.939941C17.75 0.939941 18.23 1.41994 18.23 1.99994V9.64994C18.23 10.2399 17.75 10.7099 17.17 10.7099V10.7199Z"
                    fill="#7C7C7C"
                  />
                  <path
                    [ngClass]="{ 'active-mood-svg': isSelected === true }"
                    id="Vector_5"
                    d="M21 6.89002H13.35C12.76 6.89002 12.29 6.41002 12.29 5.83002C12.29 5.25002 12.77 4.77002 13.35 4.77002H21C21.59 4.77002 22.06 5.25002 22.06 5.83002C22.06 6.41002 21.58 6.89002 21 6.89002Z"
                    fill="#7C7C7C"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
      }

      @case ('Assessments') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.36 22.36">
          <g>
            <rect width="22.36" height="22.36" fill="none" />
            <!--
              Radar / spider chart. r=10.2 fills the viewBox to ~90% (matching
              the visual weight of sibling sidebar icons) while leaving room for
              the 0.9-unit outer stroke (stroke-width 1.8 centred on the path).
              Centre is shifted to (11.0, 11.18) — about 0.2 viewBox units left
              of the geometric centre — to compensate for the slight optical
              right-lean the icon picked up when stacked next to symmetric
              sibling icons in the sidebar.
              Drawn back-to-front:
                1. Outer pentagon outline as a path with cornerRadius=1.5 — each
                   vertex is a quadratic Bezier curve (before_V → V control → after_V)
                   so the corners read as softly rounded instead of sharp wireframe.
                2. Five spokes from centre to each rounded-corner apex so they
                   meet the curved boundary cleanly (and don't poke through it).
                3. Data polygon with mirror-symmetric ratios 0.45/0.65/0.55/0.55/0.65
                   (top/TR/BR/BL/L) — varied enough to read as a radar reading
                   rather than a plain smaller pentagon, but symmetric across the
                   vertical axis so the filled mass stays centred. Sized at ~57%
                   so the outer pentagon + spokes stay visible as the radar-chart
                   "scaffold" around the fill. Solid-filled to match the
                   silhouette density of sibling icons (Clients, Admins head, etc.).
              The pentagon + spokes use the stroke-only `active-mood-stroke` class so
              their `fill="none"` is preserved when selected; the data polygon takes
              both classes since it has both a fill and an outline.
            -->
            <g
              [ngClass]="{ 'active-mood-stroke': isSelected === true }"
              stroke="#7C7C7C"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
              fill="none"
            >
              <path
                d="M 12.21 1.86 L 19.49 7.15 Q 20.70 8.03 20.24 9.46 L 17.46 18.00 Q 17.00 19.43 15.50 19.43 L 6.50 19.43 Q 5.00 19.43 4.54 18.00 L 1.76 9.46 Q 1.30 8.03 2.51 7.15 L 9.79 1.86 Q 11.00 0.98 12.21 1.86 Z"
              />
              <line x1="11.00" y1="11.18" x2="11.00" y2="1.42" />
              <line x1="11.00" y1="11.18" x2="20.28" y2="8.17" />
              <line x1="11.00" y1="11.18" x2="16.74" y2="19.07" />
              <line x1="11.00" y1="11.18" x2="5.26" y2="19.07" />
              <line x1="11.00" y1="11.18" x2="1.72" y2="8.17" />
            </g>
            <polygon
              [ngClass]="{
                'active-mood-svg': isSelected === true,
                'active-mood-stroke': isSelected === true,
              }"
              fill="#7C7C7C"
              stroke="#7C7C7C"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
              points="11.00,6.59 17.31,9.13 14.30,15.72 7.70,15.72 4.70,9.13"
            />
          </g>
        </svg>
      }
    }
  </div>
</div>
